var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgColorPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28571 1.99998C2.57562 1.99998 1.99998 2.57562 1.99998 3.28571V21.5714C1.99998 22.2815 2.57562 22.8572 3.28571 22.8572H14.7143C15.4244 22.8572 16 22.2815 16 21.5714V3.28571C16 2.57562 15.4244 1.99998 14.7143 1.99998H3.28571ZM0 3.28571C0 1.47106 1.47106 0 3.28571 0H14.7143C16.5289 0 18 1.47106 18 3.28571V21.5714C18 23.3861 16.5289 24.8572 14.7143 24.8572H3.28571C1.47106 24.8572 0 23.3861 0 21.5714V3.28571Z",
    fill: "#410BF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00024 19.2858C8.00024 18.7335 8.44795 18.2858 9.00023 18.2858H9.01166C9.56394 18.2858 10.0117 18.7335 10.0117 19.2858C10.0117 19.838 9.56394 20.2857 9.01166 20.2857H9.00023C8.44795 20.2857 8.00024 19.838 8.00024 19.2858Z",
    fill: "#8EE267"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorPhone);
export default __webpack_public_path__ + "static/media/color-phone.5e3fa17b.svg";
export { ForwardRef as ReactComponent };